const TEMPLATE_GAME_FIELDS = [
  'name',
  'pattern',
  'prizeAmount',
  'customPattern',
];

const cloneValue = (value) => {
  if (value == null) return value;
  return JSON.parse(JSON.stringify(value));
};

export const sanitizeProgramSchedule = (schedule = []) => (
  Array.isArray(schedule)
    ? schedule.map((entry, index) => {
      const cleanEntry = {
        id: `game-${index + 1}`,
        gameNumber: index + 1,
        type: entry.type || 'game',
      };

      TEMPLATE_GAME_FIELDS.forEach((field) => {
        if (entry[field] !== undefined) cleanEntry[field] = cloneValue(entry[field]);
      });

      cleanEntry.name = cleanEntry.name || `Game ${index + 1}`;
      cleanEntry.pattern = cleanEntry.pattern || '';
      cleanEntry.prizeAmount = cleanEntry.prizeAmount ?? '';
      cleanEntry.customPattern = cleanEntry.customPattern || null;
      return cleanEntry;
    })
    : []
);

export const createEventScheduleFromTemplate = (schedule = []) => (
  sanitizeProgramSchedule(schedule).map((entry, index) => ({
    ...entry,
    id: `game-${Date.now()}-${index + 1}`,
    gameNumber: index + 1,
    generatedNumbers: [],
    currentBall: null,
    nextBall: null,
    status: 'scheduled',
    startedAt: null,
    completedAt: null,
    completed: false,
  }))
);

export const duplicateProgramSchedule = (schedule = []) => (
  sanitizeProgramSchedule(schedule).map((entry, index) => ({
    ...entry,
    id: `game-${Date.now()}-${index + 1}`,
  }))
);
